<template>
  <div>
    <div class="content-header">
      <div class="left">客户管理</div>
      <div class="right">
        <Button
          icon="md-add"
          type="primary"
          @click="editChange(false)"
          v-if="$CheckShow($route.name, 'EDIT')"
          >新增客户</Button
        >
      </div>
      <div class="bottom">
        <div class="bottom_left">
          <p class="tag_p">
            <span class="tag" @click="setTabs(null)" :class="{ active: page.user_type == null }"
              >全部</span
            >
            <span class="tag" @click="setTabs(0)" :class="{ active: page.user_type == 0 }"
              >会员</span
            >
            <span class="tag" @click="setTabs(1)" :class="{ active: page.user_type == 1 }"
              >经销商</span
            >
          </p>
        </div>
        <div class="bottom_right">
          <Input
            v-model="page.key"
            style="width: 280px"
            maxlength="11"
            placeholder="手机号/账号搜索"
          ></Input>
          <Button
            type="primary"
            style="margin-left: 10px"
            icon="ios-search"
            @click="getData"
            >搜索</Button
          >
          <Button style="margin-left: 10px" @click="Reset()">重置</Button>
        </div>
      </div>
    </div>
    <div>
      <Table :columns="columns" :data="data">
        <template slot-scope="{ row }" slot="avatar">
          <div>
            <img
              :src="row.avatar"
              alt
              srcset
              v-if="row.avatar"
              style="height: 50px"
            />
            <span v-else>-</span>
          </div>
        </template>
      </Table>
      <div class="t-right t-top-10">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :total="page.total"
          show-elevator
          show-sizer
          show-total
        />
      </div>
    </div>

    <Modal
      v-model="modal.status"
      title="修改客户类型"
      @on-ok="customerSaveUser"
      @on-cancel="cancel"
      width="450"
    >
      <Form
        ref="form"
        :model="params"
        :rules="modal.rule"
        inline
        :label-width="100"
      >
        <FormItem prop="shop_user_type_id" label="会员类型:" class="fromitem">
          <Select
            v-model="params.shop_user_type_id"
            @on-change="selectUserType"
          >
            <Option :value="0">注册会员</Option>
            <Option v-for="item in type" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="alias" label="单位名称:" class="" v-if="user_type">
          <Input
            v-model="params.alias"
            type="text"
            style="width: 100%"
            placeholder="填写单位名称"
          ></Input>
        </FormItem>
        <FormItem prop="pay_type" label="信用结算:" class="fromitem">
          <Switch v-model="params.pay_type" @on-change="changePayType" :disabled="!user_type ? true : false" >{{params.pay_type==0?'关闭':'打开'}}</Switch>

          <!-- <Select
            v-model="params.pay_type"
            :disabled="!user_type ? true : false"
          >
            <Option :value="0">先付</Option>
            <Option :value="1">后付</Option>
          </Select> -->
        </FormItem>
        <FormItem
          prop="credit_line"
          label="授信额度:"
          class="fromitem"
          v-if="params.pay_type === 1"
        >
          <Input
            v-model="params.credit_line"
            type="text"
            style="width: 100px; margin-right: 10px"
            placeholder="填写授信额度"
            :disabled="modal.credit_line_status"
          ></Input>
          <Checkbox v-model="modal.credit_line_status">无限制</Checkbox>
        </FormItem>
      </Form>
      <div slot="footer" class="drawer-footer">
        <Button @click="cancel" style="margin-right: 10px">取消</Button>
        <Button
          type="primary"
          @click="customerSaveUser"
          :loading="modal.loading"
          >确定</Button
        >
      </div>
    </Modal>

    <Modal
      v-model="modalEdit.status"
      :title="modal.title"
      @on-ok="customerSaveUser"
      @on-cancel="cancel"
      width="600"
      footer-hide
    >
      <customer-edit
        :UserData="modalEdit.data"
        :Show="modalEdit.status"
        @cancelChange="cancelChange"
        @successChange="successChange"
      />
    </Modal>

    <Modal
      v-model="modalAddress.status"
      title="收货地址"
      width="800"
      footer-hide
    >
      <customer-Address :UserId="modalAddress.UserId" />
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import customerEdit from "./edit";
import customerAddress from "./address/index";
export default {
  components: {
    customerEdit,
    customerAddress,
  },
  data() {
    return {
      modalAddress: {
        status: false,
        UserId: 0,
      },
      modalEdit: {
        status: false,
        loading: false,
        data: {
          id: 0,
          tel: "",
          shop_user_type_id: 0,
          name: "",
          staff_id: 0,
          shop_id: 0,
          credit_line: null,
          pay_type: "0",
          shop_user_id: 0,
          area: [],
          email: "",
          birthday: "",
          note: "",
          alias: "",
        },
      },
      data: [],
      columns: [
        {
          title: "编号",
          key: "shop_user_id",
          width: 90,
        },
        {
          title: "手机号/账号",
          key: "tel",
          width: 150,
        },
         {
          title: "客户类型",
          key: "user_type",
          width: 150,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.user_type==1? '经销商': "会员"
            );
          },
        },
        {
          title: "客户等级",
          key: "user_type_name",
          width: 150,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.user_type_name && data.row.user_type_name !== null
                ? data.row.user_type_name
                : "注册会员"
            );
          },
        },
        {
          slot: "avatar",
          title: "头像",
          width: 120,
        },
        {
          title: "昵称",
          key: "name",
          width: 200,
        },
        {
          title: "单位名称",
          key: "alias",
          width: 200,
        },
        {
          title: "邮箱地址",
          key: "email",
          width: 200,
        },
        {
          title: "所在地区",
          key: "area",
          width: 200,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.area.length ? data.row.area.join(",") : "-"
            );
          },
        },
        {
          title: "购买次数",
          key: "",
          width: 100,
        },
         {
          title: "总消费额",
          key: "",
          width: 150,
        },
         {
          title: "最近购买时间",
          key: "",
          width: 150,
        },
        // {
        //   title: "折扣率",
        //   key: "discount",
        //   width: 80,
        //   render: (h, data) => {
        //     return h(
        //       "span",
        //       {},
        //       data.row.discount ? data.row.discount + "%" : "无折扣"
        //     );
        //   },
        // },
        // {
        //   title: "付款方式",
        //   key: "pay_type",
        //   width: 100,
        //   render: (h, data) => {
        //     return h(
        //       "span",
        //       {},
        //       data.row.pay_type === 0
        //         ? "现付"
        //         : data.row.pay_type === 1
        //         ? "后付"
        //         : "未指定-默认现付"
        //     );
        //   },
        // },
        // {
        //   title: "授信额度",
        //   key: "credit_line",
        //   width: 100,
        //   render: (h, data) => {
        //     return h(
        //       "span",
        //       {},
        //       data.row.pay_type === 1 && data.row.credit_line_status
        //         ? "无限制"
        //         : data.row.credit_line
        //     );
        //   },
        // },
        // {
        //   title: "已使用额度",
        //   key: "credit_line_use",
        //   width: 100,
        // },
        {
          title: "注册时间",
          key: "create_time",
          width: 150,
          render: (h, data) => {
            return h("span", {}, this.$moment(data.row.create_time));
          },
        },
        {
          title: "最后登录时间",
          key: "create_time",
          width: 150,
          render: (h, data) => {
            return h("span", {}, this.$moment(data.row.login_time));
          },
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          fixed: "right",
          render: (h, data) => {
            if (this.$CheckShow(this.$route.name, "EDIT")) {
              return [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small",
                    },
                    on: {
                      click: () => {
                        this.editChange(data.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    style: {
                      marginLeft: "5px",
                    },
                    props: {
                      type: "primary",
                      size: "small",
                    },
                    on: {
                      click: () => {
                        this.addressChange(data.row.id);
                      },
                    },
                  },
                  "收货地址"
                ),
              ];
            }
          },
        },
      ],
      page: {
        l: 10,
        p: 0,
        total: 0,
        user_type:null,
        key: "",
      },
      params: {
        shop_user_id: 0,
        user_id: 0,
        shop_id: null,
        shop_user_type_id: null,
        pay_type: 0,
        credit_line: null,
      },
      user_type: 0,
      modal: {
        title:'新增会员',
        status: false,
        credit_line_status: false,
        loading: false,
        rule: {
          shop_user_type_id: [
            {
              required: true,
              message: "请选择账号类型",
              trigger: "blur",
              type: "number",
            },
          ],
          alias: [
            {
              required: true,
              message: "请填写单位名称",
              trigger: "blur",
            },
          ],
        
        },
      },
      type: [],
    };
  },
  mounted() {
    this.getData();
    this.getType();
  },
  methods: {
    ...mapActions(["CustomerList", "CustomerSaveUser", "getClientType"]),
    setTabs(e) {
      this.page.p = 0;
      this.page.user_type = e;
      this.getData();
    },
    getData() {
      this.CustomerList(this.page).then((res) => {
        res.data.map((item) => {
          item.area = item.area ? item.area.split(",") : [];
          if (!item.shop_user_type_id) item.shop_user_type_id = 0;
        });
        this.data = res.data;
        this.page.total = res.total;
      });
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    customerSaveUser() {
      this.$refs.form.validate((valid) => {
        if (!valid) return false;
        if (
          this.params.pay_type == 1 &&
          !this.modal.credit_line_status &&
          this.params.credit_line <= 0
        ) {
          this.$Message.error("请输入授信额度");
          return false;
        }
        this.modal.loading = true;
        this.CustomerSaveUser(this.params).then((res) => {
          this.modal.loading = false;
          this.modal.status = false;
          if (res.status) {
            this.$Message.success(res.msg);
            this.getData();
            return false;
          }
          this.$Message.error(res.msg);
        });
      });
    },
    cancel() {
      this.params = {
        shop_user_id: 0,
        user_id: 0,
        shop_id: null,
        shop_user_type_id: null,
        pay_type: 0,
        credit_line: null,
      };
      this.modal.status = false;
    },
    getType() {
      this.getClientType({ l: 1000, p: 0 }).then((res) => {
        this.type = res.data;
      });
    },
    Reset() {
      this.page.key = "";
      this.page.p = 0;
      this.getData();
    },
    editChange(data) {
      this.modalEdit.status = true;
      if (!data){
        data = {
          id: 0,
          tel: "",
          shop_user_type_id: 0,
          name: "",
          staff_id: 0,
          shop_id: 0,
          credit_line: null,
          pay_type: "0",
          shop_user_id: 0,
          area: [],
          email: "",
          birthday: "",
          note: "",
        };
        this.modal.title = '新增客户'
      }else{
        this.modal.title = '编辑客户'
      }
      this.modalEdit.data = JSON.parse(JSON.stringify(data));
      this.user_type = data.user_type;
    },
    successChange() {
      this.modalEdit.status = false;
      this.getData();
    },
    cancelChange() {
      this.modalEdit.status = false;
      this.modalEdit.data = {
        id: 0,
        tel: "",
        shop_user_type_id: 0,
        name: "",
        staff_id: 0,
        shop_id: 0,
        credit_line: null,
        pay_type: "0",
        shop_user_id: 0,
        area: [],
        email: "",
        birthday: "",
        note: "",
      };
      this.getData();
    },
    addressChange(UserId) {
      this.modalAddress.UserId = UserId;
      this.modalAddress.status = true;
    },
    selectUserType(e) {
      if (!e) {
        this.params.pay_type = 0;
        this.user_type = 0;
        return false;
      }
      this.type.map((item) => {
        if (item.id === e) {
          this.user_type = item.type;
          if (item.type) this.params.pay_type = 1;
          else this.params.pay_type = 0;
        }
      });
    },
    changePayType(status){

    },
  },
  computed: mapGetters({}),
  watch: {
    "modal.credit_line_status": function (n, o) {
      if (n) this.params.credit_line = null;
    },
  },
};
</script>
<style lang='less' scoped>
.ivu-modal-footer {
  padding: 0;
  border: 0;
}
</style>
